interface ProductTrackingItem {
  id?: number | string | null;
  name?: string | null;
  short_name?: string | null;
  sku?: string | null;
  business_sku?: string | null;
  shop_sku?: string | null;
  products_category?: string | null;
}

interface ProductTrackingPrice {
  price?: number | string | null;
  sell_price?: number | string | null;
}

const toNumber = (value: number | string | null | undefined) => Number(value) || 0;

export function buildProductTrackingProperties(
  item: ProductTrackingItem,
  currentPrice: ProductTrackingPrice,
  basePrice: ProductTrackingPrice,
  currency?: { name?: string | null; exchange_rate?: number | string | null } | null,
) {
  return {
    product_sku: item.sku || '',
    business_sku: item.business_sku || '',
    shop_sku: item.shop_sku || '',
    product_id: item.id == null ? '' : `${item.id}`,
    product_name: item.short_name || item.name || '',
    product_class_name: item.products_category || '',
    product_price: toNumber(currentPrice.price),
    current_product_price: toNumber(currentPrice.sell_price),
    base_product_price: toNumber(basePrice.price),
    base_current_product_price: toNumber(basePrice.sell_price),
    dollar_exchange_rate: toNumber(currency?.exchange_rate),
    currency: currency?.name || '',
  };
}
